__turbopack_context__.v({
  "buttons": "HardcodedFlashMessage-module__EZQhkG__buttons",
  "continueButton": "HardcodedFlashMessage-module__EZQhkG__continueButton",
  "fadeInItems": "HardcodedFlashMessage-module__EZQhkG__fadeInItems",
  "infoButton": "HardcodedFlashMessage-module__EZQhkG__infoButton",
  "overlay": "HardcodedFlashMessage-module__EZQhkG__overlay",
  "popup": "HardcodedFlashMessage-module__EZQhkG__popup",
  "spacing--lg": "HardcodedFlashMessage-module__EZQhkG__spacing--lg",
  "spacing--md": "HardcodedFlashMessage-module__EZQhkG__spacing--md",
  "spacing--sm": "HardcodedFlashMessage-module__EZQhkG__spacing--sm",
  "spacing--xl": "HardcodedFlashMessage-module__EZQhkG__spacing--xl",
  "spacing--xs": "HardcodedFlashMessage-module__EZQhkG__spacing--xs",
  "spacing--xxl": "HardcodedFlashMessage-module__EZQhkG__spacing--xxl",
  "spacing--xxs": "HardcodedFlashMessage-module__EZQhkG__spacing--xxs",
  "spacing--xxxl": "HardcodedFlashMessage-module__EZQhkG__spacing--xxxl",
  "spacing--xxxs": "HardcodedFlashMessage-module__EZQhkG__spacing--xxxs",
});
